import { Component, OnInit } from '@angular/core';
import { AuthService } from "src/app/shared/services/auth/auth.service";
import { NgForm, FormsModule } from "@angular/forms";

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {

  paymentRequest: any = {};
  payout = "";

  constructor(
    public authService: AuthService,
  ) { }

  ngOnInit() {
    this.paymentRequest = {
      merchantID: 101381, 
      action: 'SALE', 
      type: 1, 
      countryCode : 826, 
      currencyCode : 826, 
      amount : 1001, 
      cardNumber : 4929421234600821, 
      cardExpiryMonth : 12, 
      cardExpiryYear : 15, 
      cardCVV : 356, 
      customerName : 'Test Customer', 
      customerEmail : 'test@testcustomer.com', 
      customerAddress : '16 Test Street', 
      customerPostCode : 'TE15 5ST', 
      orderRef : 'Test purchase'
    };
    let request = Object.assign({}, this.paymentRequest);
    this.authService.paymenttest(request).then((data) => {
      this.payout = data;

      console.warn(this.payout);
     
    });
  }
  

}
